<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
    >
    
    <FormItem label="分类" prop="classify_id"> 
        <Select v-model="formValidate.classify_id" clearable>
          <Option
            v-for="item in classifyIds"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="名称" prop="name">
        <Input type="textarea" v-model="formValidate.name" placeholder="请输入名称"></Input>
      </FormItem>

      <FormItem label="视频预览" v-if="video_show">
        <video :src="videoSource" ref="video" @loadedmetadata="getVideoResolution" style="width: 200px; height: auto;"></video>
      </FormItem>

      <FormItem label="请上传片段" prop="url">
          <input type="file" accept=".mp4,.MP4"  @change="handleChange" ref="pathFileInput" />
          <label class="search-label">{{show_path}}</label>
          <Button type="info" v-if='loadding' :loading="loadding">
              <span>上传中</span>
          </Button>
      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'

import moment from 'moment';
const { v4: uuidv4 } = require('uuid');
import {uploadIdFile, uploadFile} from "@/api/uploadOss";
import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds:[],
      loadding:false,
      video_show:false,
      show_path:'',
      videoSource:'',
      formValidate: {
        id: '',
        classify_id: '',
        name:'',
        url:'',
        id_url:'',
        resolving_power:''
      },
      ruleValidate: {
        classify_id: [
          {
            required: true,
            message: '分类必须选择',
            trigger: 'change'
          }
        ], name: [
          {
            required: true,
            message: '名称不能为空',
            trigger: 'blur'
          }
        ],url: [
          {
            required: true,
            message: '必须上传视频片段',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    getVideoResolution(){
      const video = this.$refs.video;
      if (video && video.videoWidth && video.videoHeight) {
        this.formValidate.resolving_power = video.videoWidth + "x" + video.videoHeight
      }
    },
    async handleChange(e){
    const file = e.target.files[0];
      if (!file) return;
      this.video_show = true
      this.videoSource = URL.createObjectURL(file);
      try {
        this.loadding = true
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        var result = null
        if (baseUrl =='https://in.sinano-ai.com/api'){
          result = await uploadIdFile('short_video/' + currentDate + "/gz_library/" + uuid + name, file);
          this.formValidate.id_url = result
        }else{
          result = await uploadFile('short_video/' + currentDate + "/gz_library/" + uuid + name, file);
          this.formValidate.url = result
        }

        if (result != ''){
          this.formValidate.url = result
          this.$Message.info('上传成功');
        }else{
          this.$Message.error('上传失败');
          this.$refs.pathFileInput.value = ''
        }
      } catch (error) {
        console.info(error)
        this.$Message.error('上传失败');
        this.$refs.pathFileInput.value = ''
      }

      this.loadding = false
   },setClassifyData (classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    setEditData (editData) {
      this.formValidate.id = editData.id
      this.formValidate.name = editData.gz_desc
      this.formValidate.classify_id = editData.gz_classify_id.toString()
      this.formValidate.url = editData.url
      this.formValidate.id_url = editData.id_url
      this.video_show = true
      this.videoSource = baseUrl == 'https://in.sinano-ai.com/api'?editData.id_url: editData.url
      if (editData.url != null){
          var video_path_array = editData.url.split("/")
          this.show_path = video_path_array[video_path_array.length - 1]
      }
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
    
  }
}
</script>
